import {HttpClient} from '../http-client';
import Season from './season';

class SeasonApi extends HttpClient {
  public constructor() {
    super(process.env.VUE_APP_API_URL)
  }

  public getSeason = async (leagueId: number, year: number): Promise<Season> => {
    const response = await this.instance.get(`season/${leagueId}/${year}/`);
    const season: Season = response.data[0];
    return season;
  };

  public getSeasonCurrent = async (leagueId: number): Promise<Season> => {
    const response = await this.instance.get(`teams/matchups/${leagueId}/`);
    const season: Season = response.data;
    return season;
  }
}

export const seasonApi = new SeasonApi();